export class CustomFilters {
    filters: Map<string, string>;
    parent?: string;
    scrollY?: number;
}
